import cartModel from '../cart/cartModel';
import { onCheckoutClick } from '../cart/cartUtils';

import './cartTotals.scss';

/* eslint-disable camelcase */
const destroy = function destroyCartTotals() {
  [].forEach.call(
    document.querySelectorAll('.js-cartCheckout'),
    (el) => {
      el.removeEventListener('click', onCheckoutClick);
    },
  );
};

const render = function renderCartTotals(props) {
  const {
    items_subtotal_price = 0,
    total_price = 0,
  } = props;

  destroy();

  [].forEach.call(
    document.querySelectorAll('.js-cartCheckout'),
    (el) => {
      el.addEventListener('click', onCheckoutClick);
    },
  );

  /* eslint-disable no-param-reassign */
  [].forEach.call(
    document.querySelectorAll('.js-cartTotalsSubtotal'),
    (el) => {
      el.innerHTML = cartModel.stylePrice(items_subtotal_price);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-cartTotalsTotal'),
    (el) => {
      const suffix = el.getAttribute('data-suffix') || '';
      const finalPrice = cartModel.getFinalPrice();

      el.innerHTML = `${suffix}${cartModel.stylePrice(finalPrice)}`;
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-cartTotalsShipping'),
    (el) => {
      const shippingPrice = cartModel.getShipping();
      el.innerHTML = cartModel.stylePrice(shippingPrice);
    },
  );
  /* eslint-enable no-param-reassign */
};

const init = function initCartTotals() {
  cartModel.addCallback(render);
  if (!cartModel.getState().isFetchingisFetching) {
    cartModel.fetch();
  }
};

export default {
  destroy,
  init,
};
